<div class="d-flex align-items-center justify-content-center">
    <div class="loading" [hidden]="errorMessage" *ngIf="loading"></div>
</div>
<!-- <div class="pb-2" >
    <div class="wre-error"> </div>
</div> -->
<div *ngIf="errorMessage" class="alert alert-danger" role="alert">
    {{ errorMessageInfo }}
</div>